// extracted by mini-css-extract-plugin
var _1 = "ZGlay";
var _2 = "rckoZ";
var _3 = "nE1KO";
var _4 = "iI9P5";
var _5 = "gDeTN";
var _6 = "iX1bL";
var _7 = "DGBvR";
var _8 = "BgKwe";
var _9 = "N3DrI";
var _a = "Q8dei";
var _b = "MaT4t";
var _c = "b4RZb";
var _d = "ONgu2";
var _e = "Yaspw";
var _f = "mPdel";
var _10 = "TNz8D";
var _11 = "Jin53";
var _12 = "yLfz3";
export { _1 as "base", _2 as "cacheButton", _3 as "content", _4 as "customAttributeTable", _5 as "description", _6 as "editableIndicator", _7 as "emptyInspector", _8 as "isHighlighted", _9 as "isStickyEnd", _a as "isStickyStart", _b as "openaiButton", _c as "publish", _d as "section", _e as "spinner", _f as "statusSection", _10 as "tagsMinHeight", _11 as "unsavedChangesLabel", _12 as "warningIcon" }
